<template>
    <b-row class="justify-content-center align-items-center" id="login-form">
      <b-card class="col-3" img-src="https://synagroweb.com/wp-content/uploads/2020/04/LogoSynagrohorizontal_optimized-1024x455.png">
        <b-form class="col-12" @submit.prevent="login">
          <b-form-group
            id="input-group-1"
            label="Usuario:"
            label-for="username"
            description=""
            
          >
            <b-form-input
              id="username"
              v-model="form.username"
              required
              placeholder="Usuario"
              :state="validation()"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-2"
            label="Contraseña:"
            label-for="password"
            description=""
          >
            <b-form-input
              id="password"
              v-model="form.password"
              type="password"
              required
              placeholder="password"
              :state="validation()"
            ></b-form-input>
            <b-form-invalid-feedback :state="validation()">
              Usuario o contraseña incorrecto
            </b-form-invalid-feedback>
          </b-form-group>
          <b-button class="custom-navbar-color" block type="submit" variant="primary">Login</b-button>
        </b-form>
      </b-card>
    </b-row>

</template>

<style>
.custom-navbar-color {
  background-color: #173667;
}
</style>

<script>
import {TokenService} from '../storage/service.js'

export default {
  name: 'Login',
  props: {
    msg: String
  },
  data: function () {
    return {
      form: {
          username: '',
          password: '',
        },
    };
  },
  computed: {
    
  },
  mounted() {
    console.log(this.backendURL)
  },

  methods: {
      validation() {
        if(this.$store.state.status == 'error'){
          return false
        }
        if(this.$store.state.status == 'success')
        {
          return true
        }
        // return null
      },
      login(){
        let username = this.form.username
        let password = this.form.password
        this.$store.dispatch('login', { username, password })
       .then(() => {
          let token = TokenService.getToken()
          this.$http.defaults.headers.common = {
            "Authorization": "Token " + token,
          };
         this.$router.push('/')
         })
       .catch(
        //  err => console.log(err),
        //  console.log(this.$store.state.status)
         )
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 25px 0 0;
}


#login-form{
  height: 100vh;
  margin: 0px;
}
</style>
